/**
 * Family Handover Vault — Pillar 2 copy and section definitions.
 * Private organisation tool — not legal advice.
 */

export const HANDOVER_VAULT_TAGLINE =
  'Keep important contacts, instructions, documents and final messages in one private place.';

export const HANDOVER_VAULT_DISCLAIMER =
  'This is a private organisation tool. It does not replace a will, solicitor, attorney, executor or formal legal process.';

export const HANDOVER_VAULT_SAFETY =
  'This is not legal advice. Vault content is private by default and visible only to you in V1.';

export const HANDOVER_VAULT_PASSWORD_WARNING =
  'For security, do not store passwords here. Use a password manager and note where your family can find access instructions.';

export const HANDOVER_VAULT_PILLAR_FEATURES = [
  'Important contacts',
  'Document locations',
  'Account instructions',
  'Final messages',
  'People to notify',
  'Review reminders',
];

export const HANDOVER_VAULT_CATEGORIES = {
  important_contact: {
    id: 'important_contact',
    label: 'Important contacts',
    copy: 'Add the people your family may need to contact.',
    examples: [
      'solicitor',
      'executor',
      'doctor',
      'accountant',
      'close relatives',
      'religious or community contact',
      'funeral director if relevant',
    ],
    addLabel: 'Add contact',
  },
  document_location: {
    id: 'document_location',
    label: 'Documents & locations',
    copy: 'Record where important documents are stored.',
    examples: [
      'will',
      'insurance',
      'property papers',
      'ID documents',
      'pension documents',
      'bank letters',
      'medical preferences',
      'funeral wishes',
    ],
    addLabel: 'Add document note',
  },
  account_instruction: {
    id: 'account_instruction',
    label: 'Account instructions',
    copy: 'Leave private notes about important accounts and where information can be found.',
    warning: HANDOVER_VAULT_PASSWORD_WARNING,
    addLabel: 'Add instruction',
  },
  final_message: {
    id: 'final_message',
    label: 'Final messages',
    copy: 'Write private messages for loved ones, to be reviewed and shared only when you choose.',
    addLabel: 'Write message',
  },
  notify_person: {
    id: 'notify_person',
    label: 'People to notify',
    copy: 'Prepare a private list of people or organisations your family may need to contact.',
    addLabel: 'Add person to notify',
  },
  review_reminder: {
    id: 'review_reminder',
    label: 'Review reminders',
    copy: 'Set reminders to review your vault so it stays up to date.',
    addLabel: 'Add reminder',
    remindersHref: '/reminders',
  },
};

export const HANDOVER_VAULT_SECTION_ORDER = [
  'important_contact',
  'document_location',
  'account_instruction',
  'final_message',
  'notify_person',
  'review_reminder',
];

export const HANDOVER_VAULT_EMPTY = {
  title: 'Start with one important note.',
  copy: 'Add a contact, document location, or instruction your family may need one day.',
  actions: [
    { label: 'Add important contact', category: 'important_contact' },
    { label: 'Add document location', category: 'document_location' },
    { label: 'Write final message', category: 'final_message' },
  ],
};

export const CATEGORY_LABELS = Object.fromEntries(
  Object.entries(HANDOVER_VAULT_CATEGORIES).map(([key, val]) => [key, val.label]),
);
